import "./App.css";
import Route from "./components/Route";
import AboutPage from "./pages/AboutPage";
import HomePage from "./pages/HomePage";
import NavButton from "./components/NavButton";
import icon from "./Geomatchry Icon-Newest.png";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import CampusesPage from "./pages/CampusesPage";

function App() {
  return (
    <div className="App">
      <div className="rotating-circles">
        <div className="circle circle1"></div>
        <div className="circle circle2"></div>
        <div className="circle circle3"></div>
        <div className="circle circle4"></div>
        <div className="circle circle5"></div>
        <div className="circle circle6"></div>
      </div>

      <header className="App-header">
        <div className="App-name">
          <span>Geomatchry</span>
          <img src={icon} alt="The Geomatchry app icon"></img>
        </div>
        <div className="Nav-buttons">
          <NavButton linksTo={"/"}>Home</NavButton>
          <NavButton linksTo={"/about"}>About</NavButton>
          <NavButton linksTo={"/campuses"}>Campuses</NavButton>
        </div>
      </header>

      <div className="page-content">
        <Route path="/">
          <HomePage />
        </Route>
      </div>

      <Route path="/about">
        <AboutPage />
      </Route>

      <Route path="/campuses">
        <CampusesPage />
      </Route>

      <Route path="/terms">
        <TermsPage />
      </Route>

      <Route path="/privacy">
        <PrivacyPage />
      </Route>
    </div>
  );
}

export default App;
